import { Col, Divider, Form, Input, Row, Select } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

import { Option } from 'antd/lib/mentions';
import OptionTick from './OptionTick';
import { images } from 'src/assets/img';

function SelectComponent({ emiratesLocation, selectedEmirate }) {
	const [isDropdown, setIsDropdown] = useState(false);
	const selectRef = React.useRef(null);
	const handleInputKeyDown = (e) => {
		if (e.ctrlKey) {
			console.log('do validate');
			e.preventDefault();
		}
	};
	return (
		<>
			{' '}
			<div>
				<Select
					open={isDropdown}
					onInputKeyDown={handleInputKeyDown}
					label="test"
					className="select-ant-d-dropdown"
					dropdownStyle={{ borderBottomLeftRadius: '24px', borderBottomRightRadius: '24px' }}
					onChange={emiratesLocation}
					className="atm-input-fields ant-d-select-custom"
					style={{ width: '100%', height: 40 }}
					onClick={() => setIsDropdown(!isDropdown)}
					placeholder="All Locations"
					optionFilterProp="children"
					suffixIcon={
						isDropdown ? (
							<img src={images.up} onClick={() => setIsDropdown(true)} className="arrows-select" />
						) : (
							<img src={images.down} onClick={() => setIsDropdown(false)} className="arrows-select" />
						)
					}
					filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
					<Option value="allemirates">
						<OptionTick selectedEmirate={selectedEmirate} option="All Emirates" value="allemirates" />
					</Option>
					<Option value="abudhabi">
						<OptionTick selectedEmirate={selectedEmirate} option="Abu Dhabi" value="abudhabi" />
					</Option>
					<Option value="ajman">
						<OptionTick selectedEmirate={selectedEmirate} option="Ajman" value="ajman" />
					</Option>
					<Option value="alain">
						<OptionTick selectedEmirate={selectedEmirate} option="Al Ain" value="alain" />
					</Option>
					<Option value="dubai">
						<OptionTick selectedEmirate={selectedEmirate} option="Dubai" value="dubai" />
					</Option>
					<Option value="fujairah">
						<OptionTick selectedEmirate={selectedEmirate} option="Fujairah" value="fujairah" />
					</Option>
					<Option value="rasalkhaimah">
						<OptionTick selectedEmirate={selectedEmirate} option="Ras Al Khaimah" value="rasalkhaimah" />
					</Option>
					<Option value="sharjah">
						<OptionTick selectedEmirate={selectedEmirate} option="Sharjah" value="sharjah" />
					</Option>
				</Select>
			</div>
		</>
	);
}

export default SelectComponent;
